import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CHECKBOX_OPTIONS } from "../components/APS/Learning/constants/config";

const initialState = {
  enteredModelName: "",
  optionCheckboxes: CHECKBOX_OPTIONS.reduce(
    (acc, option) => ({ ...acc, [option.name]: false }),
    {}
  ),
  schDirection: "Fwd",
  schModelSelection: "Forward",
  enteredModelDetail: "",
  isEditMode: false,
  isScheduling: false,
  isModelProgress: false,
  // 0 대기, 1 진행중,  9취소중
  processStatus: 0,
  modelProgressStatus: 0,
  currentModelId: 0,
};

export const resetModelData = createAsyncThunk(
  "learn/resetModelData",
  async (params = null) => {
    if (params) {
      return {
        enteredModelName: params.modelName || "",
        enteredModelDetail: params.modelDetail || "",
        isEditMode: params.isEditMode || false,
      };
    } else {
      return {
        enteredModelName: initialState.enteredModelName,
        enteredModelDetail: initialState.enteredModelDetail,
        isEditMode: initialState.isEditMode,
      };
    }
  }
);

export const handleSchedulingStatus = createAsyncThunk(
  "learn/handleSchedulingStatus",
  async (params = null) => {
    if (params) {
      return {
        isScheduling: params.isScheduling || initialState.isScheduling,
        processStatus: params.processStatus || initialState.processStatus,
      };
    } else {
      return {
        isScheduling: initialState.isScheduling,
        processStatus: initialState.processStatus,
      };
    }
  }
);

export const handleModelProgressStatus = createAsyncThunk(
  "learn/handleModelProgressStatus",
  async (params = null) => {
    if (params) {
      return {
        isModelProgress: params.isModelProgress || initialState.isModelProgress,
        modelProgressStatus:
          params.modelProgressStatus || initialState.modelProgressStatus,
      };
    } else {
      return {
        isModelProgress: initialState.isModelProgress,
        modelProgressStatus: initialState.modelProgressStatus,
      };
    }
  }
);

const learnSlice = createSlice({
  name: "learn",
  initialState,
  reducers: {
    setEnteredModelName(state, action) {
      state.enteredModelName = action.payload;
    },
    setSchModelSelection(state, action) {
      state.schModelSelection = action.payload;
    },
    setEnteredModeDetail(state, action) {
      state.enteredModelDetail = action.payload;
    },
    setIsEditMode(state, action) {
      state.isEditMode = action.payload;
    },
    setSchDirection(state, action) {
      state.schDirection = action.payload;
    },
    setIsScheduling(state, action) {
      state.isScheduling = action.payload;
    },
    setProcessStatus(state, action) {
      state.processStatus = action.payload;
    },
    setModelProgressStatus(state, action) {
      state.modelProgressStatus = action.payload;
    },
    setIsModelProgress(state, action) {
      state.isModelProgress = action.payload;
    },
    setCurrentModelId(state, action) {
      state.currentModelId = action.payload;
    },
    setOptionCheckboxes: {
      reducer(state, action) {
        state.optionCheckboxes = action.payload;
      },
      prepare(newCheckboxes) {
        return {
          payload: newCheckboxes,
        };
      },
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetModelData.fulfilled, (state, action) => {
        state.enteredModelName = action.payload.enteredModelName;
        state.enteredModelDetail = action.payload.enteredModelDetail;
        state.isEditMode = action.payload.isEditMode;
      })
      .addCase(handleSchedulingStatus.fulfilled, (state, action) => {
        state.isScheduling = action.payload.isScheduling;
        state.processStatus = action.payload.processStatus;
      })
      .addCase(handleModelProgressStatus.fulfilled, (state, action) => {
        state.isModelProgress = action.payload.isModelProgress;
        state.modelProgressStatus = action.payload.modelProgressStatus;
      });
  },
});

export const {
  setEnteredModelName,
  setOptionCheckboxes,
  setSchModelSelection,
  setEnteredModeDetail,
  setIsEditMode,
  setSchDirection,
  setIsScheduling,
  setProcessStatus,
  setModelProgressStatus,
  setIsModelProgress,
  setCurrentModelId,
} = learnSlice.actions;
export default learnSlice.reducer;
